import AppDialog, { IDialogProps } from 'components/AppDialog'
import { locationHistory } from 'services/history'
import { DrawerProps } from 'antd/lib/drawer'
import AppDrawer from 'components/AppDrawer'
import { message } from 'antd'
import AppMessage from 'components/AppMessage'

export const AppEvent = {
	open: (url: string) => {
		window.open(url)
	},
	openDialog: (component?: React.ReactElement, dialog?: IDialogProps) => {
		AppDialog.open(component, dialog)
	},
	closeDialog: () => {
		AppDialog.close()
	},
	redirect: (url: string) => {
		locationHistory.get().push(url)
	},
	openDrawer: (component: React.ReactElement, drawerProps?: DrawerProps) => {
		AppDrawer.show(component, drawerProps)
	},
	closeDrawer: () => {
		AppDrawer.hide()
	},
	alert: async (msg: string) => {
		return await AppMessage.alark(msg)
	},
	confirm: async (msg: string) => {
		return await AppMessage.confirm(msg)
	},
	deleteConfirm: async (msg: string) => {
		return await AppMessage.confirm(msg, true)
	},
	successMsg: (msg: string) => {
		message.success(msg)
	},
	warnMsg: (msg: string) => {
		message.warn(msg)
	},
	errorMsg: (msg: string) => {
		message.error(msg)
	},
}



// WEBPACK FOOTER //
// ./src/components/AppEvent/index.ts